import React from "react";
import { Switch, Route } from "react-router-dom";
import DeclaracionJuradaIndex from "../screens/DeclaracionJurada/DeclaracionJuradaIndex";
import DeclaracionJuradaForm from "../screens/DeclaracionJurada/DeclaracionJuradaForm";
import AfiliadoIndex from "../screens/Afiliado/AfiliadoIndex";
import AfiliadoForm from "../screens/Afiliado/AfiliadoForm";
import BoletaIndex from "../screens/Boleta/BoletaIndex";
import BoletaForm from "../screens/Boleta/BoletaForm";
import PagoBoleta from "../screens/Boleta/PagoBoleta";
import TicketOnDemandForm from "../screens/Boleta/TicketOnDemandForm";
import EmpresaIndex from "../screens/Empresa/EmpresaIndex";
import EmpresaForm from "../screens/Empresa/EmpresaForm";
import Login from "../screens/login/LoginIndex";
import Home from "../screens/Home";
import RecoverPasswordChange from "../screens/login/RecoverPasswordChange";
import PasswordRecovery from "../screens/login/PasswordRecovery";
import HolidayIndex from "../screens/Holiday/HolidayIndex";
import HolidayForm from "../screens/Holiday/HolidayForm";
import FixedContributionIndex from "../screens/FixedContribution/FixedContributionIndex";
import FixedContributionForm from "../screens/FixedContribution/FixedContributionForm";
import UserControlIndex from "../screens/UserControl/UserControlIndex";
import UserControlForm from "../screens/UserControl/UserControlForm";
import ReSendEmailConfirm from "../screens/login/ReSendEmailConfirm";
import BICompany from "../screens/biCharts/indexEmpresas";
import BIAfiliados from "../screens/biCharts/indexAfiliados";
import BIProvincias from "../screens/biCharts/indexProvincias";
import PaymentMethodForm from "../screens/PaymentMethod/PaymentMethodForm";
import PaymentMethodIndex from "../screens/PaymentMethod/PaymentMethodIndex";
import SupportTicketIndex from "../screens/SupportTicket/SupportTicketIndex";
import SupportTicketForm from "../screens/SupportTicket/SupportTicketForm";
import EmpresaMovements from "../screens/Empresa/EmpresaMovements";
import {
	LOGIN,
	PASSWORD_RECOVERY,
	REGISTER_USER,
	CONFIRMPASSWORD,
	INDEX,
	HOLIDAYS,
	HOLIDAYS_NEW,
	HOLIDAYS_EDIT,
	DECLARACION_JURADAS,
	DECLARACION_JURADAS_NEW,
	DECLARACION_JURADAS_SHOW,
	AFILIADOS,
	AFILIADOS_NEW,
	AFILIADOS_EDIT,
	BOLETAS,
	BOLETAS_NEW,
	BOLETAS_REGENERATE,
	EMPRESAS,
	EMPRESAS_NEW,
	FIXED_CONTRIBUTIONS,
	FIXED_CONTRIBUTIONS_NEW,
	FIXED_CONTRIBUTIONS_EDIT,
	USER_CONTROL,
	USER_CONTROL_NEW,
	USER_CONTROL_EDIT,
	EMPRESAS_EDIT,
	BOLETAS_PAY,
	CONFIRMEMAIL,
	RESEND_EMAIL_CONFIRM,
	TICKET_ONDEMAND_NEW,
	TICKET_ONDEMAND_REGENERATE,
	BI_COMPANY,
	BI_AFFILIATE,
	BI_PROVINCE,
	PAYMENT_METHODS_EDIT,
	PAYMENT_METHODS_NEW,
	PAYMENT_METHODS,
	SUPPORT_TICKET_NEW,
	SUPPORT_TICKET_EDIT,
	SUPPORT_TICKET,
	EMPRESA_MOVEMENTS
} from "./RoutesConstants";

const Routes = () => {
	return (
		<Switch>
			<Route path={SUPPORT_TICKET_EDIT} component={SupportTicketForm} />
			<Route path={SUPPORT_TICKET_NEW} component={SupportTicketForm} />
			<Route path={SUPPORT_TICKET} component={SupportTicketIndex} />
			<Route path={PAYMENT_METHODS_EDIT} component={PaymentMethodForm} />
			<Route path={PAYMENT_METHODS_NEW} component={PaymentMethodForm} />
			<Route path={PAYMENT_METHODS} component={PaymentMethodIndex} />
			<Route path={BI_COMPANY} component={BICompany} />
			<Route path={BI_AFFILIATE} component={BIAfiliados} />
			<Route path={BI_PROVINCE} component={BIProvincias} />
			<Route path={CONFIRMEMAIL} component={Login} />
			<Route path={HOLIDAYS_NEW} component={HolidayForm} />
			<Route path={HOLIDAYS_EDIT} component={HolidayForm} />
			<Route path={HOLIDAYS} component={HolidayIndex} />
			<Route path={REGISTER_USER} component={EmpresaForm} />
			<Route
				path={DECLARACION_JURADAS_SHOW}
				component={DeclaracionJuradaForm}
			/>
			<Route path={DECLARACION_JURADAS_NEW} component={DeclaracionJuradaForm} />
			<Route path={DECLARACION_JURADAS} component={DeclaracionJuradaIndex} />
			<Route
				path={FIXED_CONTRIBUTIONS_EDIT}
				component={FixedContributionForm}
			/>
			<Route path={RESEND_EMAIL_CONFIRM} component={ReSendEmailConfirm} />
			<Route path={FIXED_CONTRIBUTIONS_NEW} component={FixedContributionForm} />
			<Route path={FIXED_CONTRIBUTIONS} component={FixedContributionIndex} />
			<Route path={USER_CONTROL_EDIT} component={UserControlForm} />
			<Route path={USER_CONTROL_NEW} component={UserControlForm} />
			<Route path={USER_CONTROL} component={UserControlIndex} />
			<Route path={AFILIADOS_NEW} component={AfiliadoForm} />
			<Route path={AFILIADOS_EDIT} component={AfiliadoForm} />
			<Route path={AFILIADOS} component={AfiliadoIndex} />
			<Route path={TICKET_ONDEMAND_NEW} component={TicketOnDemandForm} />
			<Route path={TICKET_ONDEMAND_REGENERATE} component={TicketOnDemandForm} />
			<Route path={BOLETAS_NEW} component={BoletaForm} />
			<Route path={BOLETAS_PAY} component={PagoBoleta} />
			<Route path={BOLETAS_REGENERATE} component={BoletaForm} />
			<Route path={BOLETAS} component={BoletaIndex} />
			<Route path={EMPRESA_MOVEMENTS} component={EmpresaMovements} />
			<Route path={EMPRESAS_NEW} component={EmpresaForm} />
			<Route path={EMPRESAS_EDIT} component={EmpresaForm} />
			<Route path={EMPRESAS} component={EmpresaIndex} />
			<Route path={CONFIRMPASSWORD} component={RecoverPasswordChange} />
			<Route path={PASSWORD_RECOVERY} component={PasswordRecovery} />
			<Route path={LOGIN} component={Login} />
			<Route path={INDEX} component={Home} />
		</Switch>
	);
};

export default Routes;



// WEBPACK FOOTER //
// ./src/config/Routes.js